import { Uuid } from "@/domains/global/identifiers";
import { api } from "@/modules/api";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { FC } from "react";
import { useParams } from "react-router";
import { Button } from "@radix-ui/themes";
import { useNavigate } from "react-router-dom";

export const SyncClientGroupsViewPage: FC = () => {
  const navigate = useNavigate();
  const { syncClientGroupId } = useParams<{ syncClientGroupId: Uuid }>();
  const queryClient = useQueryClient();

  if (!syncClientGroupId) {
    return <div>Invalid ID</div>;
  }

  const result = useQuery({
    queryKey: ["sync-client-group-by-id", syncClientGroupId],
    queryFn: () =>
      api.get("/internal/v1/sync-client-groups/{sync_client_group_id}", {
        params: {
          path: {
            sync_client_group_id: syncClientGroupId,
          },
        },
      }),
  });

  const handleDelete = async () => {
    const confirm = window.confirm(
      "Are you sure you want to delete this sync client group? This action cannot be undone."
    );

    if (!confirm) {
      alert("Cancelled");
      return;
    }

    await api.delete("/internal/v1/sync-client-groups/{sync_client_group_id}", {
      params: {
        path: {
          sync_client_group_id: syncClientGroupId,
        },
      },
    });

    queryClient.invalidateQueries({ queryKey: ["sync-client-group-by-id", syncClientGroupId] });

    alert("Sync client group deleted");

    navigate(-1);
  };

  return (
    <div>
      <h1>View SyncClientGroup</h1>
      <pre>{JSON.stringify(result.data, null, 2)}</pre>
      <br />
      <br />
      <Button variant="outline" onClick={handleDelete}>
        Delete
      </Button>
      <br />
      <br />

      <Button variant="outline" onClick={() => navigate(-1)}>
        Back
      </Button>
      <br />
      <br />
    </div>
  );
};
